/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { BeamConstancyWorkStepDto } from './BeamConstancyWorkStepDto';
import {
    BeamConstancyWorkStepDtoFromJSON,
    BeamConstancyWorkStepDtoFromJSONTyped,
    BeamConstancyWorkStepDtoToJSON,
} from './BeamConstancyWorkStepDto';
import type { InstructionDto } from './InstructionDto';
import {
    InstructionDtoFromJSON,
    InstructionDtoFromJSONTyped,
    InstructionDtoToJSON,
} from './InstructionDto';
import type { WorkItemSource } from './WorkItemSource';
import {
    WorkItemSourceFromJSON,
    WorkItemSourceFromJSONTyped,
    WorkItemSourceToJSON,
} from './WorkItemSource';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { GuidItemGroupDto } from './GuidItemGroupDto';
import {
    GuidItemGroupDtoFromJSON,
    GuidItemGroupDtoFromJSONTyped,
    GuidItemGroupDtoToJSON,
} from './GuidItemGroupDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface BeamConstancyWorkItemDto
 */
export interface BeamConstancyWorkItemDto {
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkItemDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkItemDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    taskInJobId?: string;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    taskId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    taskAreaId?: string;
    /**
     * 
     * @type {Array<GuidItemGroupDto>}
     * @memberof BeamConstancyWorkItemDto
     */
    supportSystemIds?: Array<GuidItemGroupDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof BeamConstancyWorkItemDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    description?: string | null;
    /**
     * 
     * @type {InstructionDto}
     * @memberof BeamConstancyWorkItemDto
     */
    instruction?: InstructionDto;
    /**
     * 
     * @type {WorkItemSource}
     * @memberof BeamConstancyWorkItemDto
     */
    source?: WorkItemSource;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    commentEntityCompositeId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkItemDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BeamConstancyWorkItemDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof BeamConstancyWorkItemDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<BeamConstancyWorkStepDto>}
     * @memberof BeamConstancyWorkItemDto
     */
    workSteps?: Array<BeamConstancyWorkStepDto> | null;
    /**
     * 
     * @type {string}
     * @memberof BeamConstancyWorkItemDto
     */
    $type?: BeamConstancyWorkItemDtoTypeEnum;
}


/**
 * @export
 */
export const BeamConstancyWorkItemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoBeamConstancyWorkItemDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.BeamConstancyWorkItemDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type BeamConstancyWorkItemDtoTypeEnum = typeof BeamConstancyWorkItemDtoTypeEnum[keyof typeof BeamConstancyWorkItemDtoTypeEnum];



/**
 * Check if a given object implements the BeamConstancyWorkItemDto interface.
 */
export function instanceOfBeamConstancyWorkItemDto(value?: unknown): value is BeamConstancyWorkItemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamConstancyWorkItemDtoTypeEnum)[0];
}

export function BeamConstancyWorkItemDtoFromJSON(json: any): BeamConstancyWorkItemDto {
    return BeamConstancyWorkItemDtoFromJSONTyped(json, false);
}

export function BeamConstancyWorkItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamConstancyWorkItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'taskInJobId': json['taskInJobId'] == null ? undefined : json['taskInJobId'],
        'name': json['name'] == null ? undefined : json['name'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'taskAreaId': json['taskAreaId'] == null ? undefined : json['taskAreaId'],
        'supportSystemIds': json['supportSystemIds'] == null ? undefined : ((json['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoFromJSON)),
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'taskType': json['taskType'] == null ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'description': json['description'] == null ? undefined : json['description'],
        'instruction': json['instruction'] == null ? undefined : InstructionDtoFromJSON(json['instruction']),
        'source': json['source'] == null ? undefined : WorkItemSourceFromJSON(json['source']),
        'commentEntityCompositeId': json['commentEntityCompositeId'] == null ? undefined : json['commentEntityCompositeId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'workSteps': json['workSteps'] == null ? undefined : ((json['workSteps'] as Array<any>).map(BeamConstancyWorkStepDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamConstancyWorkItemDtoToJSON(value?: Omit<BeamConstancyWorkItemDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'taskInJobId': value['taskInJobId'],
        'name': value['name'],
        'taskId': value['taskId'],
        'taskAreaId': value['taskAreaId'],
        'supportSystemIds': value['supportSystemIds'] == null ? undefined : ((value['supportSystemIds'] as Array<any>).map(GuidItemGroupDtoToJSON)),
        'iuid': value['iuid'],
        'taskType': TaskTypeDescriptionToJSON(value['taskType']),
        'description': value['description'],
        'instruction': InstructionDtoToJSON(value['instruction']),
        'source': WorkItemSourceToJSON(value['source']),
        'commentEntityCompositeId': value['commentEntityCompositeId'],
        'commentCount': value['commentCount'],
        'lastComment': value['lastComment'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'workSteps': value['workSteps'] == null ? undefined : ((value['workSteps'] as Array<any>).map(BeamConstancyWorkStepDtoToJSON)),
        '$type': value['$type'],
    });
}

